import { useState, useCallback } from 'react';
import { getNextAvailableSlot } from '../api/publicBookingApi';

const useNextAvailableSlot = (slug) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const findNextAvailable = useCallback(async (availabilityIds, startDate = null, totalServiceDuration = null) => {
    if (!slug || !availabilityIds || !Array.isArray(availabilityIds) || availabilityIds.length === 0) {
      setError('Missing required parameters');
      return;
    }

    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      const data = await getNextAvailableSlot(slug, availabilityIds, startDate, totalServiceDuration);
      setResult(data);
      return data;
    } catch (err) {
      setError(err.message);
      setResult(null);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [slug]);

  const resetState = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setResult(null);
  }, []);

  return {
    findNextAvailable,
    isLoading,
    error,
    result,
    resetState,
  };
};

export default useNextAvailableSlot;